import CalculatorSelectInput from '../../../calculatorInputs/CalculatorSelectInput';
import i18next from 'i18next';
import React from 'react';

const EqualValue = ({ showLabel, fieldName, availableValueOptions, readOnly = false }) => {
  return (
    <CalculatorSelectInput
      fieldName={`${fieldName}.${0}`}
      label={`${
        showLabel ? i18next.t('calculator.dialog.create.label.values') : ''
      }`}
      placeholder={i18next.t(
        `calculator.dialog.create.placeholder.selectValues`
      )}
      options={availableValueOptions}
      uxVariant="criteriaInput"
      variant="standard"
      isRequired
      validate={() => null}
      labelVariant="chip"
      triggerOnContinue
      disabled={readOnly}
    />
  );
};

export default EqualValue;
